import React from 'react'
import { SelectRangeInterval } from '../../../shared/chart/widget'
import { DEFAULT_INTERVALS, INTERVAL_TEXT, allowedIntervals } from './lms-insight-query'

// The filter bar of the LMS insights pages: the range and interval (the
// dashboards' SelectRangeInterval), the LMS connection, the course, and
// Refresh. The pages read on load and on Refresh, never on a timer.
//
// chosen holds what the person picked; interval is the one the reports are
// asked for (it follows the range, lms-insight-query.js effectiveInterval).
export const FilterBar = ({ chosen, interval, days, intervals = DEFAULT_INTERVALS, connections, courses, today, onChange, onRefresh }) => {
  const offered = allowedIntervals(days, intervals)
  const choices = (offered.length ? offered : intervals).map(i => ({ value: i.id, text: INTERVAL_TEXT[i.id] || i.id }))
  // the widget shows the name of the interval it is given, so it is one it has
  const shown = choices.some(choice => choice.value === interval) ? interval : choices[0].value

  return (
    <div className="d-flex flex-wrap align-items-end gap-3 mb-2" data-testid="lms-insights-filters">
      <div className="flex-grow-1" style={{ minWidth: '18rem', maxWidth: '36rem' }}>
        <SelectRangeInterval
          start={chosen.start}
          end={chosen.end}
          interval={shown}
          intervals={choices}
          maxDate={today}
          onChangeStart={start => onChange({ start })}
          onChangeEnd={end => onChange({ end })}
          onChangeInterval={next => onChange({ interval: next })}
        />
      </div>
      <select
        className="form-select form-select-sm w-auto"
        aria-label="LMS connection"
        value={chosen.connection}
        onChange={e => onChange({ connection: e.target.value, course: '' })}>
        <option value="">All LMS connections</option>
        {connections.map(connection =>
          <option key={connection.id} value={String(connection.id)}>
            {connection.archived ? `${connection.name} (archived)` : connection.name}
          </option>
        )}
      </select>
      <select className="form-select form-select-sm w-auto" aria-label="Course" value={chosen.course} onChange={e => onChange({ course: e.target.value })}>
        <option value="">All courses</option>
        {courses.map(course => <option key={course.id} value={String(course.id)}>{course.name}</option>)}
      </select>
      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onRefresh}>Refresh</button>
    </div>
  )
}
